import React, {useState} from "react";
import Grid from "@material-ui/core/Grid";
import WhiteHeaderCard from "../../../../components/ui/cards/white-header-card/WhiteHeaderCard";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import ServizioClientiPremiumCard from "../servizio-clienti-premium-card/ServizioClientiPremiumCard";
import RichiediUnaModificaDialog
    from "../../../../components/mobile/sub-menu-items/richieste-assistenza/Dialogs/RichiediUnaModificaDialog/RichiediUnaModificaDialog";
import AltereComunicazioni
    from "../../../../components/mobile/sub-menu-items/richieste-assistenza/Dialogs/AltereComunicazioniDialog/AltereComunicazioni";
import SegnalazioneDialog from "../../dialogs/segnalazione-dialog/SegnalazioneDialog";
import SegnalazioneInviataDialog
    from "../../../../components/mobile/sub-menu-items/sim/Dialogs/segnalazione-inviata-dialog/SegnalazioneInviataDialog";
import {useMediaQuery} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {colors} from "../../../colors";
import {useSelector} from "react-redux";
import {shouldAuthenticate} from "../../../utils/guard";
import FaqDialog from "../../../../components/mobile/sub-menu-items/richieste-assistenza/Dialogs/FaqDialog/FaqDialog";

const useStyles = makeStyles({
    cardContent: {
        color: colors.font.light,
    },
    contentOverline: {
        fontSize: "0.75rem",
    },
    cardContentWithoutButton: {
        minHeight: "200px",
    },
    breakWord: {
        wordBreak: "break-word",
    },
    maxWidth: {
        width: "100%",
    },
});

const ContattaciCards = (props) => {
    const classes = useStyles();
    const smScreen = useMediaQuery("(max-width: 450px)");
    const [openRichiediUnaModificaDialog, setOpenRichiediUnaModificaDialog] = useState(false);
    const [openSegnalazione, setOpenSegnalazione] = useState(false);
    const [openSegnalazioneInviata, setOpenSegnalazioneInviata] = useState(false);
    const [openAltereComunicazioni, setOpenAltereComunicazioni] = useState(false);
    const [openFaqDialog, setOpenFaqDialog] = useState(false);
    const authState = useSelector(state => state.authReducer);

    const handleOpenAltereComunicazioni = () => {
        setOpenAltereComunicazioni(true);
    };

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={4}>
                    <WhiteHeaderCard elevationValue={props.elevationValue} title={"Supporto Fastweb"}>
                        <div className={classes.cardContentWithoutButton}>
                            <Typography variant="body2" className={classes.cardContent}>
                                Consulta le FAQ per trovare le risposte che cerchi, oppure apri una segnalazione per i
                                disservizi dei tuoi asset o servizi relativi al tuo contratto.
                            </Typography>
                        </div>

                        <Grid container item
                              spacing={2}>
                            <Grid item>
                                <Button onClick={() => setOpenFaqDialog(true)}
                                        className={smScreen ? classes.maxWidth : null}
                                        variant={"outlined"} color={"secondary"}>
                                    FAQ
                                </Button>
                            </Grid>

                            <Grid item>
                                <Button onClick={() => setOpenSegnalazione(true)}
                                        disabled={!shouldAuthenticate("C", authState.userClaims.typeUser, authState.userClaims.roles)}
                                        className={smScreen ? classes.maxWidth : null}
                                        variant={"outlined"} color={"secondary"}>
                                    apri segnalazione
                                </Button>
                            </Grid>
                        </Grid>
                    </WhiteHeaderCard>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <WhiteHeaderCard elevationValue={props.elevationValue}
                                     title={"Richiedi una modifica"}>
                        <div className={classes.cardContentWithoutButton}>
                            <Typography variant="body2" className={classes.cardContent}>
                                Puoi richiedere la modifica delle principali anagrafiche del contratto:
                            </Typography>
                            <Grid container spacing={1} className={"mt-6 p-9 display-block"}>
                                <Grid item>
                                    <Typography variant={"body2"} className={classes.cardContent}>
                                        ◦ configurazioni tecniche
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant={"body2"} className={classes.cardContent}>
                                        ◦ gestione amministrativa
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant={"body2"} className={classes.cardContent}>
                                        ◦ piano e offerte
                                    </Typography>
                                </Grid>
                            </Grid>
                        </div>
                        <Button
                            className={smScreen ? classes.maxWidth : null}
                            onClick={() => setOpenRichiediUnaModificaDialog(true)}
                            variant={"outlined"}
                            color={"secondary"}
                            disabled={!shouldAuthenticate("C", authState.userClaims.typeUser, authState.userClaims.roles)}
                        >
                            richiedi ora
                        </Button>
                    </WhiteHeaderCard>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <ServizioClientiPremiumCard elevationValue={props.elevationValue}
                                                data={authState.selectedCompany}
                                                handleOpenAltereComunicazioni={handleOpenAltereComunicazioni}/>
                </Grid>
            </Grid>

            {openRichiediUnaModificaDialog ? (
                <RichiediUnaModificaDialog
                    open={openRichiediUnaModificaDialog}
                    handleDialogClose={() => setOpenRichiediUnaModificaDialog(false)}
                    handleRichiediUnaModificaCloseButton={() => setOpenRichiediUnaModificaDialog(false)}
                />
            ) : null}

            {openAltereComunicazioni ? (
                <AltereComunicazioni
                    open={openAltereComunicazioni}
                    screenCode={"E5.01.B.03-2"}
                    handleDialogClose={() => setOpenAltereComunicazioni(false)}
                    handleAltereComunicazioniCloseButton={() => setOpenAltereComunicazioni(false)}
                />
            ) : null}

            {openSegnalazione ? (
                <SegnalazioneDialog
                    open={openSegnalazione}
                    characterLimit={1000}
                    handleDialogCloseButton={() => setOpenSegnalazione(false)}
                    handleDialogClose={() => setOpenSegnalazione(false)}
                />
            ) : null}

            {openSegnalazioneInviata ? (
                <SegnalazioneInviataDialog
                    open={openSegnalazioneInviata}
                    handleDialogCloseButton={() => {
                        setOpenSegnalazioneInviata(false);
                        setOpenSegnalazione(false);
                    }}
                    handleDialogClose={() => {
                        setOpenSegnalazioneInviata(false);
                        setOpenSegnalazione(false);
                    }}
                />
            ) : null}

            {openFaqDialog ? (
                <FaqDialog open={openFaqDialog} close={() => setOpenFaqDialog(false)}/>
            ) : null}
        </>
    )
}

ContattaciCards.defaultProps = {
    elevationValue: 0
};

export default ContattaciCards;
